import SL_Logo from './SL_Logo.png';
import SL_Icon from './SL_Icon.svg';
import SF_Icon from './SF_Icon.png';
import MW_Icon from './MW_Icon.png';
import EE_Icon from './EE_Icon.png';
import SamplePartImage from './SamplePartImage.png';

export default {
    logos: {
        SPEEDlabel: SL_Logo
    },
    icons: {
        SPEEDlabel: SL_Icon,
        SPEEDfolder: SF_Icon,
        Moraware: MW_Icon,
        EasedEdge: EE_Icon
    },
    preview: {
        part: SamplePartImage
    }
};